import React from 'react'
import PropTypes from 'prop-types'
import Indicator from '../texts/indicator'
import HeadingBeta from '../headings/heading-beta'
import Breadcrumbs from '../lists/breadcrumbs'
import SocialButtons from '../social/social-buttons'
import Link from '../links/link'
import DataBlock from '../texts/data-block'

const makeContactItems = contact => {
  const items = []
  contact.phone && items.push({ icon: 'phone', text: contact.phone })
  contact.phone2 && items.push({ icon: 'phone', text: contact.phone2 })
  contact.email && items.push({ icon: 'email2', text: contact.email })
  contact.fax && items.push({ icon: 'fax', text: contact.fax })
  return items
}

const renderContacts = contacts =>
  contacts.map((contact, index) => (
    <DataBlock
      label={contact.name}
      items={makeContactItems(contact)}
      key={`contact-${index}`}
    />
  ))

const CharityContact = props => {
  const {
    charityName,
    charityLink,
    charityWebsite,
    hasSocialMedia,
    socialMedia,
    contacts,
    // translationscontactText: 'charity.contact.contact',
    contactText,
    websiteText,
    contactWithUsText
  } = props
  return (
    <div className='profile inner-wrapper-wide'>
      <Breadcrumbs
        current={contactText}
        crumbs={[{ linkText: charityName, linkUrl: charityLink }]}
      />
      <HeadingBeta>{charityName}</HeadingBeta>
      <Indicator className='shy-indicator' labelText={websiteText}>
        <Link href={charityWebsite}>{charityWebsite}</Link>
      </Indicator>
      {hasSocialMedia && (
        <Indicator className='shy-indicator' labelText={contactWithUsText}>
          <SocialButtons socialMedia={socialMedia} />
        </Indicator>
      )}
      {contacts && contacts.length ? renderContacts(contacts) : null}
    </div>
  )
}

CharityContact.propTypes = {
  charityName: PropTypes.string,
  charityLink: PropTypes.string,
  charityWebsite: PropTypes.string,
  hasSocialMedia: PropTypes.bool,
  socialMedia: PropTypes.shape({
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.strin,
    google: PropTypes.string
  }),
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
      phone2: PropTypes.string,
      fax: PropTypes.string
    })
  ),
  // translations
  contactText: PropTypes.string,
  websiteText: PropTypes.string,
  contactWithUsText: PropTypes.string
}

export default CharityContact



// WEBPACK FOOTER //
// ./src/ui/views/charity-contact.js